import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// Title of a card or table: the icon in a soft tile, the title at 15/600 and an optional line under it.
// Anything passed as children sits on the same line, after the title (a selector, a counter…).
export default function AppCardTitle({ icon, title, subtitle, iconBg = dsColorNew.pillActiveBg, iconColor = dsColorNew.appBlue, children, sx = {} }) {
	return <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minHeight: 40, ...sx }}>
		{!!icon && <Box component="span" sx={{
			width: 32, height: 32, borderRadius: '8px', flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
			backgroundColor: iconBg, color: iconColor,
		}}>
			<IconSeeker icon={icon} sx={{ fontSize: 13 }}/>
		</Box>}
		<Box component="span" sx={{ display: 'flex', flexDirection: 'column' }}>
			<Typography component="span" sx={{ fontSize: 15, fontWeight: 600, color: dsColorNew.textTitle, lineHeight: 1.3 }}>{title}</Typography>
			{!!subtitle && <Typography component="span" sx={{ fontSize: 13, color: dsColorNew.textMuted }}>{subtitle}</Typography>}
		</Box>
		{children}
	</Box>
}
